import classNames from 'classnames';
import React from 'react';
import { useFieldView } from '../contexts/form-view-context';
import styles from '../ui/form/components/grid/responsive-grid.module.scss';
import { useResponsiveGrid } from '../ui/form/components/grid/use-responsive-grid';
import { isInputField } from '../ui/form/types';
import { calculateGridStyles } from '../utils/grid-styles';
import { useScrollWhenFocused } from './use-scroll-when-focused';
export const DefaultFieldLayout = ({ fieldId, ...rest })=>{
    const fieldView = useFieldView(fieldId);
    const responsiveGrid = useResponsiveGrid();
    const cellRef = useScrollWhenFocused(fieldId);
    if (!fieldView) {
        return null;
    }
    const { layout, fieldType } = fieldView;
    const dataHook = `form-field-${isInputField(fieldView) ? fieldView.target : fieldView.id}`;
    const dataAttributes = {
        'data-hook': dataHook,
        'data-field-type': fieldType
    };
    const cellProps = getCellProps(layout, responsiveGrid?.fields.get(fieldId));
    if ('children' in rest) {
        return /*#__PURE__*/ React.createElement("div", {
            ref: cellRef,
            ...cellProps.container,
            ...dataAttributes
        }, rest.children);
    }
    const { renderLabel, renderInput, renderDescription } = rest;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", cellProps.label, renderLabel()), /*#__PURE__*/ React.createElement("div", {
        ref: cellRef,
        ...cellProps.input,
        ...dataAttributes
    }, renderInput(), renderDescription()));
};
function getCellProps(layout, variables) {
    if (!variables) {
        const { label, input, container } = calculateGridStyles({
            layout
        });
        return {
            label: {
                style: label
            },
            input: {
                style: input
            },
            container: {
                style: container
            }
        };
    }
    return {
        label: {
            style: variables.label,
            className: classNames(styles.cell, styles.label)
        },
        input: {
            style: variables.input,
            className: styles.cell
        },
        container: {
            style: variables.container,
            className: styles.cell
        }
    };
}

//# sourceMappingURL=default-field-layout.js.map